import HeaderStyled from "./HeaderStyled";

const Header = () => {
  return (
    <HeaderStyled>
      <span className="iconContainer">
        <svg width="32" height="32" viewBox="0 0 32 32">
          <g fill="white">
            <path d="M18.9,32h4.9c4.5,0,8.2-3.7,8.2-8.2v0V8.2C32,3.7,28.3,0,23.8,0c0,0,0,0,0,0h-5c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0v31.6C18.6,31.9,18.7,32,18.9,32z M25,14.4c1.8,0,3.2,1.5,3.2,3.2c0,1.8-1.5,3.2-3.2,3.2c-1.8,0-3.2-1.4-3.2-3.2C21.7,15.8,23.2,14.4,25,14.4C25,14.4,25,14.4,25,14.4z M15.2,0h-7C3.7,0,0,3.7,0,8.2v15.6C0,28.3,3.7,32,8.2,32h7c0.1,0,0.2-0.1,0.2-0.2l0,0V0.2C15.4,0.1,15.3,0,15.2,0C15.2,0,15.2,0,15.2,0z M12.9,29.4H8.2c-3.1,0-5.6-2.5-5.6-5.6V8.2c0-3.1,2.5-5.6,5.6-5.6h4.6L12.9,29.4z M5,9.6c0,1.7,1.3,3,3,3s3-1.3,3-3s-1.3-3-3-3S5,7.9,5,9.6L5,9.6z"></path>
          </g>
        </svg>
      </span>
      <span>Switch Shmups</span>
    </HeaderStyled>
  );
};

export default Header;
